import { computed, defineComponent } from '@vue/composition-api';
export default defineComponent({
    name: 'DpPercentBar',
    props: {
        state: { type: String, default: 'error' },
        text: { type: String, default: '0%' },
        value: { type: Number, default: 0 },
    },
    setup(props) {
        const percent = computed(() => `${props.value}%`);
        const indicatorStyle = computed(() => ({
            width: percent.value,
        }));
        const stateClass = computed(() => {
            const { state } = props;
            const ragMap = {
                RED: 'error',
                AMBER: 'warning',
                GREEN: 'positive',
            };
            return ragMap[state] || state;
        });
        return {
            percent,
            indicatorStyle,
            stateClass,
        };
    },
});
